__turbopack_context__.v({
  "cookiesBannerBtn": "cookiesBanner-module-scss-module__wC6gTa__cookiesBannerBtn",
  "cookiesBannerClose": "cookiesBanner-module-scss-module__wC6gTa__cookiesBannerClose",
  "cookiesBannerContent": "cookiesBanner-module-scss-module__wC6gTa__cookiesBannerContent",
  "cookiesBannerLink": "cookiesBanner-module-scss-module__wC6gTa__cookiesBannerLink",
  "cookiesBannerManageBtn": "cookiesBanner-module-scss-module__wC6gTa__cookiesBannerManageBtn",
  "cookiesBannerText": "cookiesBanner-module-scss-module__wC6gTa__cookiesBannerText",
  "cookiesBannerWrapper": "cookiesBanner-module-scss-module__wC6gTa__cookiesBannerWrapper",
  "cookiesCheckboxes": "cookiesBanner-module-scss-module__wC6gTa__cookiesCheckboxes",
  "cookiesManageBlock": "cookiesBanner-module-scss-module__wC6gTa__cookiesManageBlock",
  "functionalCheckbox": "cookiesBanner-module-scss-module__wC6gTa__functionalCheckbox",
  "marketingCheckbox": "cookiesBanner-module-scss-module__wC6gTa__marketingCheckbox",
  "marketingLabel": "cookiesBanner-module-scss-module__wC6gTa__marketingLabel",
});
